import { useQuery } from "@tanstack/react-query";
import { GeofencesService } from "../services/geofences.service";
import { GeofenceSearchParams } from "../domain/geofence.interface";

export const useGeofenceSearch = (params: GeofenceSearchParams) => {
  return useQuery({
    queryKey: [
      "coyn-geofence-search",
      params.pageNumber,
      params.pageSize,
      params.sortField,
      params.sortOrder,
      params.search,
      params.action,
      params.addressType,
      params.programId,
      params.dateFrom,
      params.dateTo,
    ],
    queryFn: () => GeofencesService.search(params),
  });
};

export const useGeofenceById = (id: string) => {
  return useQuery({
    queryKey: ["coyn-geofence-by-id", id],
    queryFn: () => GeofencesService.findById(id),
    enabled: !!id,
  });
};
